import React from "react"

import {LexicalEditor} from "lexical"
import ControlButtonStandard from "../../../../../../buttons/control-button/control-button-standard"
import {FontColorType} from "../../../../highlight/font-color/font-color-plugin"
import {BadgeType} from "../../../../highlight/badge/badge-plugin"
import IconFontComponent from "./icon-font-color";
import IconBGComponent from "./icon-bg-color";

type Props = {
    menuParams: {
        fontColorType   : FontColorType | null
        badgeType       : BadgeType | null
        options         : any[]
        editor          : LexicalEditor
    }
    hidePopover : callback
}

const debug = false
// const debug = "ToolbarColorButton"

export default function ToolbarColorButton(state: any, props: Props) {

    const classes = Classes("flex-row-center-center", {
        'show-popover': state.showPopover
    })

    debug && console.log(debug, 'process', props)

    let content
    if (props.menuParams.fontColorType) {
        content     = <IconFontComponent className="icon" colorStyleType={props.menuParams.fontColorType}/>
    } else if (props.menuParams.badgeType) {
        content     = <IconBGComponent className="icon" colorStyleType={props.menuParams.badgeType}/>
    } else {
        content = <div className="ui5-ico-16 editor-i5-color"/>
    }

    return (
        <ControlButtonStandard className={classes}>
            {content}
        </ControlButtonStandard>
    )
}